import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import { useSpring, animated } from 'react-spring' // web.cjs is required for IE 11 support
import { Tuning } from './tunings'
import TuningsAutocomplete from './TuningsAutocomplete'
import InstrumentAutocomplete from './InstrumentsAutocomplete'
import { Typography } from '@material-ui/core'
import SoundsAutocomplete from './SoundsAutocomplete';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  title: {
    color: 'white',
    borderBottom: '2px solid lightgrey',
    paddingBottom: 18,
    marginBottom: 45,
    marginTop: 14
  }
}))

const Fade = React.forwardRef(function Fade(props, ref) {
  // @ts-ignore
  const { in: open, children, onEnter, onExited, ...other } = props
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter()
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited()
      }
    },
  })

  return (
    // @ts-ignore
    <animated.div ref={ref} style={style} {...other}>
      {children}
    </animated.div>
  )
})

export default function SettingsModal(props: {
  open: boolean,
  onClose: () => void,
  settings: any,
  onSettingsChange: (settings: any) => void,
  tunings: Tuning[],
  instruments: any[],
  sounds: any[],
}) {

  const {
    open,
    onClose,
    settings,
    onSettingsChange,
    tunings,
    instruments,
    sounds
  } = props

  const classes = useStyles()

  return (
    <Modal
      id="settings-modal"
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      className={classes.modal}
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {/* @ts-ignore */}
      <Fade in={open}>
        <div className={classes.paper}>

          <Typography className={classes.title} variant="h3">Settings</Typography>

          <InstrumentAutocomplete
            instruments={instruments}
            instrument={settings.instrument}
            onInstrumentChange={(instrument: any) => onSettingsChange({ ...settings, instrument })}
            outlined
          />

          <TuningsAutocomplete
            tunings={tunings}
            tuning={settings.tuning}
            instrument={settings.instrument}
            onTuningChange={(tuning: Tuning) => onSettingsChange({ ...settings, tuning })}
          />

          <SoundsAutocomplete
            sounds={sounds}
            sound={settings.sound}
            onSoundChange={(sound: any) => onSettingsChange({ ...settings, sound })}
          />

        </div>
      </Fade>
    </Modal>
  )
}

// TODO : at what pich the scale/chord should be played (0, 1, 2, 3, 4, ...)

// TODO : Add fret start & length